import React, { Component } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DatePickerInput from "./DatePickerInput";
import { request } from "./../../../../config";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

class AddCarModal extends Component {
  state = {
    carNumber: "",
    finCode: "",
    birthDate: "",
    note: "",
    fineNotification: true,
    parkingNotification: true,
    isLoading: false,
  };

  getFormatedDate(date) {
    if (date) {
      let formatedDate = {
        day: date.getDate() < 9 ? "0" + date.getDate() : date.getDate(),
        month:
          date.getMonth() < 9
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1,
        year: date.getFullYear().toString(),
      };
      // return formatedDate.day + '-' + formatedDate.month + '-' + formatedDate.year;
      return (
        formatedDate.year + "-" + formatedDate.month + "-" + formatedDate.day
      );
    }
    return null;
  }

  resetForm = () => {
    this.setState({
      carNumber: "",
      finCode: "",
      birthDate: "",
      note: "",
      fineNotification: true,
      parkingNotification: true,
      isLoading: false,
    });
  };

  handleChange = (field, value) => {
    this.setState({ [field]: value });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.isValid()) return;
    const { onAdd, onSuccess } = this.props;
    // if (!onAdd) return;

    this.setState({ isLoading: true });

    let getAddCarRequestBody = {
      token: localStorage.getItem("token"),
      lang: localStorage.getItem("i18nextLng").toUpperCase(),
      birthDate: this.getFormatedDate(this.state.birthDate),
      carNumber: this.state.carNumber,
      finCode: this.state.finCode,
      fineNotification: this.state.fineNotification,
      note: this.state.note,
      parkingNotification: this.state.parkingNotification,
    };

    fetch(request("car/add", getAddCarRequestBody))
      .then((res) => res.text())
      .then((getAddCarResponseJSON) => {
        const JSON = require("true-json-bigint");
        let res = JSON.parse(getAddCarResponseJSON);

        if (res.status.statusCode !== 1) {
          if (res.status.statusCode === 200) {
            this.props.logout();
          } else {
            this.props.alertState(
              true,
              "error",
              this.props.t("an error occurred"),
              this.props.t(res.status.statusCode),
            );
            this.setState({ isLoading: false });
          }
          return;
        }

        this.handleClose();

        this.props.alertState(
          true,
          "success",
          this.props.t("successful operation"),
          this.props.t("car added successfully"),
        );

        this.props.onSuccess();

        this.setState({ isLoading: false });
      });
  };

  isValid = () => {
    const { carNumber, finCode, birthDate, note } = this.state;

    return (
      carNumber.trim().length > 0 &&
      finCode.trim().length > 0 &&
      note.trim().length > 0 &&
      birthDate
    );
  };

  handleClose = () => {
    this.props.onClose();
  };

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open && !this.props.open) {
      this.resetForm();
    }
  }

  render() {
    const { open, t } = this.props;

    const {
      carNumber,
      finCode,
      birthDate,
      note,
      fineNotification,
      parkingNotification,
      isLoading,
    } = this.state;

    return (
      <Dialog
        open={open}
        onClose={this.handleClose}
        fullWidth
        maxWidth="xs"
        disableEnforceFocus
        disableAutoFocus
        disableScrollLock
      >
        <form onSubmit={(e) => this.handleSubmit(e)}>
          {/* Header */}
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              fontWeight: 600,
            }}
          >
            {t("Add car")}
            <IconButton onClick={this.handleClose}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          {/* Content */}
          <DialogContent>
            <div className="dashboard-payment-parking-add-car-form">
              {/* Car number */}
              <div className="dashboard-payment-parking-form-group">
                <label>{t("car number")}</label>
                <input
                  value={carNumber}
                  placeholder={t("insert")}
                  maxLength="10"
                  onChange={(e) => {
                    const value = e.target.value
                      .replace(/[^A-Za-z0-9]/g, "")
                      .toUpperCase();

                    this.handleChange("carNumber", value);
                  }}
                />
              </div>

              {/* FIN */}
              <div className="dashboard-payment-parking-form-group">
                <label>{t("Pin code")}</label>
                <input
                  value={finCode}
                  placeholder="12345678"
                  maxLength="8"
                  onChange={(e) => {
                    let value = e.target.value;

                    // remove non-english letters & numbers
                    value = value.replace(/[^A-Za-z0-9]/g, "");

                    // convert to uppercase
                    value = value.toUpperCase();

                    this.handleChange("finCode", value);
                  }}
                />
                <p className="dashboard-payment-parking-right-container-info">
                  <InfoOutlinedIcon fontSize="small" />
                  {t("fin_code_info")}
                </p>
              </div>

              {/* Birth date */}
              <div className="dashboard-payment-parking-form-group">
                <label>{t("Date of birth")}</label>
                <DatePickerInput
                  value={birthDate ? new Date(birthDate) : null}
                  updateDate={(date) => this.handleChange("birthDate", date)}
                />
              </div>

              {/* Note */}
              <div className="dashboard-payment-parking-form-group">
                <label>{t("note")}</label>
                <input
                  value={note}
                  placeholder={t("add note")}
                  onChange={(e) => this.handleChange("note", e.target.value)}
                />
              </div>

              {/* Notifications */}
              <div
                style={{ marginTop: "1.5rem" }}
                className="dashboard-payment-parking-right-container-notifications"
              >
                <div className="dashboard-payment-parking-right-container-notification">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div className="dashboard-payment-parking-right-container-notification-title">
                      {t("fine notices")}
                    </div>
                    <div className="dashboard-payment-parking-right-container-notification-description">
                      {t("Fine notices description")}
                    </div>
                  </div>
                  <div
                    className={`dashboard-payment-parking-right-container-notification-switch ${
                      fineNotification ? "checked" : ""
                    }`}
                    onClick={() =>
                      this.handleChange("fineNotification", !fineNotification)
                    }
                  >
                    <div className="dashboard-payment-parking-right-container-notification-switch-track">
                      <div className="dashboard-payment-parking-right-container-notification-switch-thumb"></div>
                    </div>
                  </div>
                </div>
                <div className="dashboard-payment-parking-right-container-notification">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div className="dashboard-payment-parking-right-container-notification-title">
                      {t("parking notices")}
                    </div>
                    <div className="dashboard-payment-parking-right-container-notification-description">
                      {t("Parking notices description")}
                    </div>
                  </div>
                  <div
                    className={`dashboard-payment-parking-right-container-notification-switch ${
                      parkingNotification ? "checked" : ""
                    }`}
                    onClick={() =>
                      this.handleChange(
                        "parkingNotification",
                        !parkingNotification,
                      )
                    }
                  >
                    <div className="dashboard-payment-parking-right-container-notification-switch-track">
                      <div className="dashboard-payment-parking-right-container-notification-switch-thumb"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>

          {/* Actions */}
          <DialogActions sx={{ p: "1rem" }}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={isLoading || !this.isValid()}
              sx={{
                height: "48px",
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              {isLoading ? t("Loading...") : t("Add to")}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}

export default AddCarModal;
